import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function Field({ label, children, hint, className = "" }) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <Label className="text-xs font-medium text-slate-600">{label}</Label>
      {children}
      {hint && <span className="text-xs text-slate-500">{hint}</span>}
    </div>
  );
}

export function TextField({ label, value, onChange, type = "text", testId, hint, ...rest }) {
  return (
    <Field label={label} hint={hint}>
      <Input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="h-10 bg-white" {...rest} />
    </Field>
  );
}

export function NumberField({ label, value, onChange, testId, hint, step = "any", ...rest }) {
  return (
    <Field label={label} hint={hint}>
      <Input type="number" inputMode="decimal" step={step} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="h-10 bg-white tnum" {...rest} />
    </Field>
  );
}

export function SelectField({ label, value, onChange, options, testId, placeholder = "Seleziona", hint, disabled }) {
  return (
    <Field label={label} hint={hint}>
      <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="h-10 bg-white" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {options.map((o) => {
            const v = typeof o === "string" ? o : o.value;
            const l = typeof o === "string" ? o : o.label;
            return <SelectItem key={v} value={v} data-testid={`${testId}-option-${v}`}>{l}</SelectItem>;
          })}
        </SelectContent>
      </Select>
    </Field>
  );
}
